import * as React from 'react';

import { DateContainer } from 'containers/project-love/date/date-container';

const DatePage: React.FunctionComponent = () => {
  return <DateContainer />;
};

export default DatePage;

export { getServerSideProps } from 'lib/get-server-side-props';
